import React, { useState, useEffect } from 'react';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import { testimonials } from '../data/products';

const Testimonials = () => {
    const [currentTestimonial, setCurrentTestimonial] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => setCurrentTestimonial((prev) => (prev + 1) % testimonials.length), 4000);
        return () => clearInterval(timer);
    }, []);

    return (
        <section id="testimonios" className="py-20 md:py-28 bg-gradient-to-b from-white to-dulce-pink-50/30 relative overflow-hidden">
            <div className="absolute top-0 left-1/2 w-96 h-96 bg-dulce-pink-100/30 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl" />

            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="animate-on-scroll">
                    <div className="text-center mb-16">
                        <span className="inline-block text-dulce-pink-500 text-sm font-semibold tracking-widest uppercase mb-3">
                            ⭐ Testimonios ⭐
                        </span>
                        <h2 className="section-title text-gray-800">
                            Lo que dicen nuestros <span className="text-gradient-pink">Clientes</span>
                        </h2>
                        <p className="section-subtitle">La satisfacción de nuestros clientes es nuestra mejor receta 💕</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {testimonials.map((testimonial, index) => (
                            <div key={testimonial.id}
                                className={`bg-white rounded-2xl p-6 shadow-lg border border-dulce-pink-100/50 transition-all duration-500 ${index === currentTestimonial ? 'scale-105 shadow-xl border-dulce-pink-300' : 'hover:shadow-lg hover:-translate-y-1'
                                    }`}>
                                <FaQuoteLeft className="text-dulce-pink-200 mb-3" size={24} />
                                <p className="text-gray-600 text-sm leading-relaxed mb-4 italic">"{testimonial.text}"</p>
                                <div className="flex items-center gap-3">
                                    <span className="text-3xl">{testimonial.avatar}</span>
                                    <div>
                                        <p className="font-semibold text-gray-800 text-sm">{testimonial.name}</p>
                                        <div className="flex gap-0.5">
                                            {[...Array(testimonial.rating)].map((_, i) => <FaStar key={i} className="text-amber-400" size={12} />)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="flex justify-center gap-2 mt-8">
                        {testimonials.map((_, index) => (
                            <button key={index} onClick={() => setCurrentTestimonial(index)}
                                className={`h-2 rounded-full transition-all duration-300 ${index === currentTestimonial ? 'w-8 bg-dulce-pink-500' : 'w-2 bg-dulce-pink-200'
                                    }`} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

